import { Device } from "@/__generated__/graphql";
import { FormValues } from "@features/createDeviceConfiguration/type/FormValues";
import { Typography, Grid } from "@mui/material";
import { Control } from "react-hook-form";
import OptionSelector from "../../OptionSelector";
import { FormInputText } from "@components/form";
import useHardwareOptions from "@features/createDeviceConfiguration/hooks/useHardwareOptions";

interface DeviceSensorsFormProps {
  device: Device;
  control: Control<FormValues>;
}

const DeviceSensorsForm = ({
  device,
  control,
}: DeviceSensorsFormProps) => {

  return (
    <Grid container spacing={2} sx={{ justifyContent: 'center' }}>
      {(device.sensors ?? []).map((sensor, index) => (
        <Grid item xs={12} md={6} key={index}>
          <Typography variant="h6" color="textSecondary" mt={2} ml={1}>
            Sensor {index + 1} - {sensor?.type?.label}
          </Typography>
          <Grid item xs={12} mt={2}>
            <OptionSelector
              options={
                useHardwareOptions(`${sensor?.type?.name}_sensor`).options
              }
              label="Tipo de sensor *"
              name={`sensors[${index}].sensorModelOption`}
              control={control}
            />
          </Grid>
          <Grid item xs={12} mt={2}>
            <FormInputText
              name={`sensors[${index}].serialNumber`}
              control={control}
              label="Número de serie del sensor"
            />
          </Grid>
          <Grid item xs={12} mt={2}>
            <FormInputText
              name={`sensors[${index}].modbusId`}
              control={control}
              label="Modbus ID del sensor"
            />
          </Grid>
          <Grid item xs={12} mt={2}>
            <FormInputText
              name={`sensors[${index}].batchNumber`}
              control={control}
              label="Número de lote del sensor"
            />
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
}

export default DeviceSensorsForm;
